/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react'
import { useMergeState } from '../../../irmlib/src/hooks'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'
import { setBusy, clearBusy } from 'irmlib/containers'
import { useTranslation } from 'react-i18next'
// import { FormControl } from '@mui/material'
import { OutlinedButton } from 'irmlib/components/Controls'
import Dropdown from '../../../irmlib/src/components/Controls/Dropdown'
import GroupedAssetType from '../../../irmlib/src/components/Controls/GroupedAssetType'
import { useHistory } from 'react-router-dom'
import { getUser } from '../../../redux/global'
import * as routePaths from '../../../navigation/routePaths'
import { FormControl, Autocomplete, TextField } from '@mui/material'

const initialSate = {
  assetTypes: {},
  templateDatas: [],
  templateTypes: [],
  selectedCustomerID: [],
  selectedAssetTypes: [],
  selectedTemplateTypes: [],
  customerId: [],
  customerId2: [],
  customerId3: [],
  wmsInstance: []
}

const LocalTemplateFilters = (props) => {
  const [state, setState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const [selectedAssetTypes, setSelectedAssetTypes] = useState('')
  const [selectedCustomerID, setSelectedCustomerID] = useState('')
  const [selectedCustomerID2, setSelectedCustomerID2] = useState('')
  const [selectedCustomerID3, setSelectedCustomerID3] = useState('')
  const [selectedTemplateType, setSelectedTemplateType] = useState('')
  const [selectedWmsInstance, setSelectedWmsInstance] = useState('')
  const restoredFilterKeyRef = useRef(null)

  useEffect(() => {
    const { workerId } = getUser()
    getWmsInstance(workerId)
    // getCustomerID()
    getTemplateAssetTypes()
  }, [])

  useEffect(() => {
    const f = props.filterSnapshot
    if (!f || !f.wmsInstance || !state.wmsInstance?.length) return

    const key = JSON.stringify({
      wms: f.wmsInstance,
      c1: f.customoerId?.value,
      c2: f.customoerId2?.value,
      c3: f.customoerId3?.value,
      asset: f.assetType,
      tpl: f.templateType,
    })
    if (restoredFilterKeyRef.current === key) return
    restoredFilterKeyRef.current = key

    let cancelled = false
    ;(async () => {
      setSelectedWmsInstance(f.wmsInstance)
      await getCustomerID(f.wmsInstance)
      if (cancelled) return
      setSelectedCustomerID(f.customoerId || null)
      setSelectedCustomerID2(f.customoerId2 || null)
      setSelectedCustomerID3(f.customoerId3 || null)
      setSelectedAssetTypes(f.assetType || '')
      await getTemplateAssetTypes(f.assetType)
      if (cancelled) return
      setSelectedTemplateType(f.templateType || '')
    })()
    return () => {
      cancelled = true
    }
  }, [props.filterSnapshot, state.wmsInstance])

  const getTemplateAssetTypes = async (value) => {
    setBusy()
    // const [lineOfBusiness, assetType, templateType, customTemplateName, , , wmsConfig] =
    //   await localGdeTransactions.getGdeConfig()
    const [, assetType, , templateType] = await localGdeTransactions.getGdeConfig()
    // let templateTypeData
    // if (value === 'Box Transmittal') {
    //   templateTypeData = Object.entries(templateType)
    //     .filter(([key, value]) => value.name.toLowerCase().includes('maintenance'))
    //     .map(([key, value]) => ({ value: value.name, label: value.name }))
    // } else {
    //   templateTypeData = Object.entries(templateType).map(
    //     ([key, value]) => ({ value: value.name, label: value.name })
    //   )
    // }

    Object.entries(assetType).forEach(([key, value]) => {
      if (value.name === 'Transmittal Sheet') {
        value.isActive = false
      }
    })
    const templateTypeData = Object.entries(templateType).map(
      ([key, value]) => ({ value: value.name, label: value.name })
    )

    setState({
      assetTypes: assetType,
      templateTypes: templateTypeData,
    })
    clearBusy()
  }

  const getCustomerID = async (wmsCodeSelected) => {
    setBusy()
    const collection = await localGdeTransactions.getCustomerID()
    let CustomerId = []
    let CustomerId2 = []
    let CustomerId3 = []
    collection.forEach((doc) => {
      const accountLevel1 = doc.data().accountLevel1
      const accountLevel2 = doc.data().accountLevel2
      const accountLevel3 = doc.data().accountLevel3
      const wmsCode = doc.data().wmsCode
      if (accountLevel1 && accountLevel1.trim() !== '' && wmsCodeSelected === wmsCode) {
        if (accountLevel1 !== 'GLOBALTEMPLATE') {
          CustomerId.push({
            value: accountLevel1.trim(),
            label: accountLevel1.trim(),
          })
        }
      }
      if (accountLevel2 && accountLevel2.trim() !== '' && wmsCodeSelected === wmsCode) {
        CustomerId2.push({
          value: accountLevel2.trim(),
          label: accountLevel2.trim(),
        })
      }
      if (accountLevel3 && accountLevel3.trim() !== '' && wmsCodeSelected === wmsCode) {
        CustomerId3.push({
          value: accountLevel3.trim(),
          label: accountLevel3.trim(),
        })
      }
    })
    CustomerId = Array.from(
      new Set(CustomerId.map((item) => JSON.stringify(item)))
    ).map((item) => JSON.parse(item))
    CustomerId2 = Array.from(
      new Set(CustomerId2.map((item) => JSON.stringify(item)))
    ).map((item) => JSON.parse(item))
    CustomerId3 = Array.from(
      new Set(CustomerId3.map((item) => JSON.stringify(item)))
    ).map((item) => JSON.parse(item))
    setState({ customerId: CustomerId })
    setState({ customerId2: CustomerId2 })
    setState({ customerId3: CustomerId3 })
    clearBusy()
  }

  const getWmsInstance = async (workerId) => {
    setBusy()
    const workerDetailsGde = await localGdeTransactions.getWorkerRoleGde(workerId)
    const doc = await localGdeTransactions.getSkpInstance(workerDetailsGde?.gdeCountryCode)
    const wmsList = []
    if (doc && 'skp' in doc) {
      const skpInstance = doc.skp.instances[0]
      setState({ wmsRegion: skpInstance })
      if (skpInstance !== undefined) {
        wmsList.push({
          value: 'SKP', label: 'SKP'
        })
      }
    }
    
    if (doc && 'oneil' in doc) {
      const oneilInstance = doc.oneil.instances
      const instances = oneilInstance.map((key) => ({ value: key, label: key }))
      setState({ wmsRegions: instances })
      if (instances?.length > 0) {
        wmsList.push({
          value: 'ONEIL', label: 'ONEIL'
        })
      }
    }

    setState({
      wmsInstance: wmsList
    })
    clearBusy()
  }

  const handleCLick = () => {
    // getStdTemplateFileds()
    props.selectedData({
      wmsInstance: selectedWmsInstance,
      customoerId: selectedCustomerID,
      customoerId2: selectedCustomerID2,
      customoerId3: selectedCustomerID3,
      assetType: selectedAssetTypes,
      templateType: selectedTemplateType,
    })
  }
  const history = useHistory()

  const onClick = (route) => {
    history.push(route)
  }

  const onChangeWms = (value) => {
    setSelectedWmsInstance(value)
    getCustomerID(value)
  }

  const handleAssetChange = (e) => {
    setSelectedAssetTypes(e.target.value)
    getTemplateAssetTypes(e.target.value)
  }

  state.templateTypes.forEach((element, index) => {
    if (element.label !== '--Select--') {
      element.label = t(`dropdowns.${element.value}`)
    }
  })

  return (
    <>
      <Dropdown
        options={state.wmsInstance}
        label={t('Search.wms',)}
        value={selectedWmsInstance}
        onChange={(e) => {
          onChangeWms(e.target.value)
        }}
      ></Dropdown>
      <Autocomplete
        sx={{ m: 1, width: '15%' }}
        size="small"
        label= {t('templates.accountLevelOne')}
        options= {state.customerId}
        value={selectedCustomerID || null}
        getOptionLabel={(option) => option.label}
        onChange={(e, value) => setSelectedCustomerID(value)}
        renderInput={(params) => (
          <TextField {...params} label={t('templates.accountLevelOne')} variant="outlined" />
        )}
      />
      <Autocomplete
        sx={{ m: 1, width: '15%' }}
        size="small"
        label= {t('templates.accountLevelTwo')}
        options= {state.customerId2}
        value={selectedCustomerID2 || null}
        getOptionLabel={(option) => option.label}
        onChange={(e, value) => setSelectedCustomerID2(value)}
        renderInput={(params) => (
          <TextField {...params} label={t('templates.accountLevelTwo')} variant="outlined" />
        )}
      />
      <Autocomplete
        sx={{ m: 1, width: '15%' }}
        size="small"
        label= {t('templates.accountLevelThree')}
        options= {state.customerId3}
        value={selectedCustomerID3 || null}
        getOptionLabel={(option) => option.label}
        onChange={(e, value) => setSelectedCustomerID3(value)}
        renderInput={(params) => (
          <TextField {...params} label={t('templates.accountLevelThree')} variant="outlined" />
        )}
      />
      {/* <Dropdown
        options={state.customerId}
        label={t('templates.customerId')}
        onChange={(e) => {
          setSelectedCustomerID(e.target.value)
        }}
      ></Dropdown> */}
      <GroupedAssetType
        assetTypes={state.assetTypes}
        label={t('templates.assetType')}
        value={selectedAssetTypes}
        onChange={(e) => {
          handleAssetChange(e)
        }}
      />
      <Dropdown
        options={state.templateTypes}
        label={t('templates.templateType')}
        value={selectedTemplateType}
        onChange={(e) => {
          setSelectedTemplateType(e.target.value)
        }}
      ></Dropdown>
      <FormControl
        sx={{ m: 1, width: 'fitContent' }}
        size={'small'}
      >
        <OutlinedButton
          id={'allJobs_createJob'}
          variant='contained'
          onClick={handleCLick}
          disabled={
            !selectedWmsInstance || !selectedCustomerID || !selectedAssetTypes || !selectedTemplateType
          }
        >
          forms.Search
        </OutlinedButton>
      </FormControl>
      {getUser().role === 'SUPER USER'
        ? <FormControl
            sx={{ m: 1, width: 'fitContent', display: 'flex', justifyContent: 'center' }}
            size={'small'}
          >
          <OutlinedButton
            sx={{ height: '50px' }}
            id={'allJobs_createJob'}
            variant='contained'
            onClick={() => onClick(routePaths.localcreateActivity)}
          >
            dashBoard.createNewTemplate
          </OutlinedButton>
        </FormControl>
        : null}
    </>
  )
}
export default LocalTemplateFilters
